import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  changePlanzone(credentials: Boundaries["changePlanzone"]["request"]): void;
}

function useChangePlanzone(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isChangePlanzoneRequestPending),
    isRequestSuccess: useSelector(selector.isChangePlanzoneRequestSuccess),
    isRequestFailure: useSelector(selector.isChangePlanzoneRequestFailure),
    changePlanzone: core.changePlanzone,
  };
}

export { useChangePlanzone };
